import { makeStyles } from '@material-ui/styles';
import { colors } from '@material-ui/core';

const styles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
    background: 'linear-gradient(to right, #c252ac, #0066a0)',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },
  flexGrow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  verificationMessage: {
    color: '#FFF',
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(1),
    [theme.breakpoints.up('xl')]: {
      fontSize: 18,
    },
  },
  logoutButton: {
    marginLeft: theme.spacing(1),
  },
  logoutIcon: {
    marginRight: theme.spacing(1),
  },
  warningButton: {
    color: colors.yellow['600'],
  },
  userEmail: {
    color: '#fff',
    marginLeft: theme.spacing(2),
  },
}));

export default styles;
